
const cartDrawer = () => {
  return {
    open: false,
    cart: {
      item_count: 0
    },
    messageOpened: false,
    items: [],
    discountCode: null,
    validDiscountCode: "",
    freeShippingFrom: 5000,
    checkoutCart: {
      total: 0,
      subtotal: 0,
      discount: 0
    },
    codeStatus: null,
    usedKeyboard: false,
    choiceOverlay: false,
    width() {
      if (this.checkoutCart.total < this.freeShippingFrom) {
        return Math.abs(this.checkoutCart.total / this.freeShippingFrom * 100);
      }
      return 100
    },
    init(cart) {
      this.cart = cart;
      this.checkoutCart.total  = this.cart.total_price 
      this.items = cart.items;
      this.$watch('open', value => {
        value && this.$refs.closeButton.focus()

        if (!value) {
          window.dispatchEvent( new CustomEvent('cart-closed', {}) );
        }
        this.toggleOverlay()
      })
      this.toggleOverlay()
    },
    image(item) {
      let image = item.featured_image.url
      image = image.replace(".png", "_100x.png")
      image = image.replace(".jpg", "_100x.jpg")
      image = image.replace(".jpeg", "_100x.jpeg")
      return image
    },
    shippingDiff(text, format) {
      var total = (this.checkoutCart !== undefined && this.checkoutCart.total > 0) ? this.checkoutCart.total : 0;
      const diff = this.freeShippingFrom - this.checkoutCart.total;
      const t = text.replace("[money]", Shopify.formatMoney(diff, format))
      return t
    },
    plus(index, item) {
      CartJS.addItem(item, 1);
    },
    minus(index, quantity) {
      CartJS.updateItem(index + 1, quantity);
    },
    update(index, quantity) {
      const newQty = quantity > 99 ? 99 : quantity;
      CartJS.updateItem(index + 1, newQty);
    },
    toggleOverlay() {
      document.body.classList[this.open ? 'add' : 'remove']('tw-h-screen', 'tw-overflow-hidden')
    }
  }
}


document.addEventListener("DOMContentLoaded", function(event) {
  $(document).on('click', '.mobile-menu__top-level', function(){
    var handle = $(this).attr('data-menu-click');

    $(".mobile-menu__top-level").removeClass("active")
    $('[data-menu-click="'+handle+'"]').addClass("active")

    $(".mobile-menu__top-level-links").hide()

    $('[data-menu-handle="'+handle+'"]').show()
  });
})

/*$(document).on('click', '.title_item_menu', function(){
  var sliderTitle = $(this).attr('data-titles');
    console.log(sliderTitle);
    $('.navigation__tier-1 .navigation__item--with-title[data-menu-title="'+sliderTitle+'"] .navigation__link.navigation__item--with_link').trigger('click');
});*/
/*======Match height =========*/
/* setTimeout(function () {
      $('.equal-height').matchHeight({ 
      byRow: true,
      property: 'height',
      target: null,
      remove: false
      });
  }, 1000);*/

document.addEventListener('DOMContentLoaded', function() {
  var style = document.createElement('style');
  style.textContent = '.widerrufs-button { display: inline-block; padding: 10px 20px; background-color: #08ae81; color: #fff !important; border-radius: 4px; text-decoration: none; font-weight: bold; } .widerrufs-button:hover { background-color: #595a5b; color: #fff !important; }';
  document.head.appendChild(style);

  document.querySelectorAll('.section-footer__menu-block__menu a').forEach(function(link) {
    if (link.textContent.trim() === 'Vertrag widerrufen') {
      link.classList.add('widerrufs-button');
    }
  });
});

